import axios from '../../config/axios.js'
import router from '../../config/router.js'
import store from '../../vuex/store.js'
import { addIso690 } from '../../custom/function.js'

const STATE = {

    document: {},
    referred_docs: [],
    referring_docs: [],
    projects: [],
    originals: [],
    translations: [],
    pre_versions: [],
    post_versions: [],
    wholes: [],
    parts: [],
    note: null,

}

const GETTERS = {

    document: state => state.document,
    referred_docs: state => state.referred_docs,
    referring_docs: state => state.referring_docs,
    projects: state => state.projects,
    originals: state => state.originals,
    translations: state => state.translations,
    pre_versions: state => state.pre_versions,
    post_versions: state => state.post_versions,
    wholes: state => state.wholes,
    parts: state => state.parts,
    note: state => state.note,

}

const MUTATIONS = {

    getDocument(state, document) {
        state.document = document
    },

    setDocument(state, document) {
        state.document = document
    },

    getReferredDocs(state, document) {
        state.referred_docs = document
    },

    getReferringDocs(state, document) {
        state.referring_docs = document
    },

    getProjects(state, projects) {
        state.projects = projects
    },

    getOriginals(state, docs) {
        state.originals = docs
    },

    getTranslations(state, docs) {
        state.translations = docs
    },

    getPreVersions(state, docs) {
        state.pre_versions = docs
    },

    getPostVersions(state, docs) {
        state.post_versions = docs
    },

    getWholes(state, docs) {
        state.wholes = docs
    },

    getParts(state, docs) {
        state.parts = docs
    },

    getDocumentNote(state, note) {
        state.note = note
    },

}

const ACTIONS = {

    async getDocument({ commit, dispatch }, doc_key) {
        await axios.ACCESS.get('/api/bt/document/' + doc_key)
            .then(res => {
                // console.log('document/getDocument', res)
                if (res.data.result) {
                    addIso690([res.data.document])
                        .then(res => {
                            res.forEach(doc => Object.keys(doc).forEach(k => doc[k] = doc[k] == 'null' ? 'n.r.' : doc[k]))
                            commit('getDocument', res[0])
                        })
                } else {
                    throw new Error(res.data)
                }
            })
        await axios.ACCESS.get('/api/bt/document/' + doc_key + '/references')
            .then(res => {
                // console.log('document/getReferences', res)
                addIso690(res.data.referred_docs)
                    .then(res => {
                        res.forEach(doc => Object.keys(doc).forEach(k => doc[k] = doc[k] == 'null' ? 'n.r.' : doc[k]))
                        commit('getReferredDocs', res)
                    })
                addIso690(res.data.referring_docs)
                    .then(res => {
                        res.forEach(doc => Object.keys(doc).forEach(k => doc[k] = doc[k] == 'null' ? 'n.r.' : doc[k]))
                        commit('getReferringDocs', res)
                    })
            })
            // await axios.ACCESS.get('/api/bt/document/' + doc_key + '/translations')
            //     .then(res => {
            //         console.log('document/getTranslations', res.data)
            //         commit('getOriginals', res.data.original_docs)
            //         commit('getTranslations', res.data.translated_docs)
            //     })
            // await axios.ACCESS.get('/api/bt/document/' + doc_key + '/revisions')
            //     .then(res => {
            //         console.log('document/getRevisions', res.data)
            //         commit('getPreVersions', res.data.original_docs)
            //         commit('getPostVersions', res.data.revised_docs)
            //     })
            // await axios.ACCESS.get('/api/bt/document/' + doc_key + '/parts')
            //     .then(res => {
            //         console.log('document/getParts', res.data)
            //         commit('getWholes', res.data.whole_docs)
            //         commit('getParts', res.data.part_docs)
            //     })
            // await dispatch('getProjects', doc_key)
    },

    async getProjects({ commit }, doc_key) {
        await axios.ACCESS.post('/api/projects', { doc_key })
            .then(res => {
                // console.log('document/getProjects', res)
                commit('getProjects', res.data.projects)
            })
    },

    async createDocumentNote({ dispatch }, payload) {
        await axios.ACCESS.post('/api/documentnote', {
                doc_key: payload.doc_key,
                note: payload.note,
                important: payload.important,
            })
            .then(res => {
                // console.log('document/createDocumentNote', res)
                if (res.data.result) {
                    dispatch('getDocument', payload.doc_key)
                    store.dispatch('project/getProject', {
                        proj_id: payload.proj_id
                    })
                } else { throw new Error(res.data) }
            })
    },

    async updateDocumentNote({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/documentnote/' + payload.note_id, {
                note: payload.note,
                important: payload.important,
            })
            .then(res => {
                // console.log('document/updateDocumentNote', res)
            })
    },

    async deleteDocumentNote({ commit }, note_id) {
        await axios.ACCESS.delete('/api/documentnote/' + note_id)
            .then(res => {
                // console.log('document/deleteDocumentNote', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async getDocumentNote({ commit }, doc_key) {
        await axios.ACCESS.get('/api/document/' + doc_key + '/note')
            .then(res => {
                // console.log('document/getDocumentNote', res)
                commit('getDocumentNote', res.data.note.note)
                if (!res.data.result) { throw new Error(res.data) }
            })
    }

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/document.js